import { useEffect, useState } from 'react'
import { timeZoneList, updateTimeZone, logOutApi } from '../../../Context/api';
import axios from 'axios';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const UseTimeZone = () => {
    const [timeZoneData, setTimeZoneData] = useState([])
    const [spinner, setSpinner] = useState(false)
    const [active, setActive] = useState('true')
    const [count, setCount] = useState(1)
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()


    useEffect(() => {
        getTimeZone()
    }, [active, page])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const getTimeZone = () => {
        setSpinner(true)
        axios.post(timeZoneList(), { isActive: active === 'true', page: page, count: PER_PAGE }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setTimeZoneData(resp.data)
                setCount(resp.data.totalCount)
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setTimeZoneData([])
                setSpinner(false)
                setCount(1)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    const changeStatus = (item) => {
        setSpinner(true)
        axios.post(updateTimeZone(), { id: item._id, isActive: !item.isActive }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                setSpinner(false)
                getTimeZone()
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
    }
    return {
        timeZoneData,
        spinner,
        active,
        page,
        PER_PAGE,
        count,
        setPage,
        setActive,
        changeStatus
    }
}

export default UseTimeZone